import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { UserEffects } from "./user.effects";
import { userReducer } from "./user.reducer";

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature("user", userReducer),
        EffectsModule.forFeature([UserEffects]),
    ],
    providers: []
})
export class UserStateModule { }
